import React from 'react';
import { Col, Container } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { getMonthName, MONTHS } from './utils';
import * as Constants from "./constants";
import { SectionSelectBox } from './SectionSelectBox';
import { SelectBox } from './SelectBox';

export const MapFilter = ({
    year,
    years,
    handleYearChanged,
    startMonth,
    handleStartMonthChanged,
    endMonth,
    sectionNumber,
    sections,
    handleSectionChanged,
    productType,
    productTypes,
    handleProductTypeChanged,
    handleEndMonthChanged,
    selectedMapType,
    handleMapTypeChanged
}) => {
    const months = MONTHS;
    const startMonthName = getMonthName(startMonth);
    const endMonthName = getMonthName(endMonth);
    return (
        <Container>
            <Form onSubmit={(event) => event.preventDefault()}>
                <Form.Row>
                    <Form.Label column sm={2} md={50}>
                        Family:
                        </Form.Label>
                    <Form.Group as={Col} sm={10} md="100%" controlId="mapSection">
                        <SectionSelectBox
                            selectedSectionNumber={sectionNumber}
                            sections={sections}
                            onSectionChanged={handleSectionChanged}>
                        </SectionSelectBox>
                    </Form.Group>
                </Form.Row>
                {productTypes && (<Form.Row>
                    <Form.Label column sm={2} md={50}>
                        Product Type:
                        </Form.Label>
                    <Form.Group as={Col} sm={10} md="100%" controlId="mapProductType">
                        <SelectBox
                            items={productTypes}
                            selectedValue={productType}
                            onSelectionChanged={handleProductTypeChanged}
                        />
                    </Form.Group>
                </Form.Row>)}
                <Form.Row>
                    <Form.Label column sm={2}>
                        Year:
                        </Form.Label>
                    <Form.Group as={Col} sm={4} controlId="mapYear">
                        <SelectBox
                            items={years}
                            selectedValue={year}
                            onSelectionChanged={value => handleYearChanged(parseInt(value))}
                        />
                    </Form.Group>
                    <Form.Label column sm={1} style={{ textAlign: "right" }}>
                        Months:
                        </Form.Label>
                    <Form.Group as={Col} sm={2} controlId="mapStartMonth">
                        <SelectBox
                            items={months}
                            selectedValue={startMonthName}
                            onSelectionChanged={handleStartMonthChanged}
                        />
                    </Form.Group>
                    <Form.Label column sm={1} style={{ textAlign: "center" }}>
                        through
                        </Form.Label>
                    <Form.Group as={Col} sm={2} controlId="mapEndMonth">
                        <SelectBox
                            items={months}
                            selectedValue={endMonthName}
                            onSelectionChanged={handleEndMonthChanged}
                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Label column sm={2} md={50}>
                        Group data by:
                    </Form.Label>
                    <Form.Check
                        inline
                        type="radio"
                        label="State"
                        name="mapType"
                        id="mapUSRegions"
                        defaultChecked={selectedMapType === Constants.MAP_TYPE_US_REGIONS}
                        onChange={() => handleMapTypeChanged(Constants.MAP_TYPE_US_REGIONS)}
                    />
                    <Form.Check
                        inline
                        type="radio"
                        label="City"
                        name="mapType"
                        id="mapDecisionLocation"
                        defaultChecked={selectedMapType === Constants.MAP_TYPE_DECISION_LOCATION}
                        onChange={() => handleMapTypeChanged(Constants.MAP_TYPE_DECISION_LOCATION)}
                    />
                </Form.Row>
            </Form>
        </Container>
    );

}